import { useEffect } from 'react';
import type { IOcrkV1DiagnosticReportCustomControlData } from '@common/interfaces/ophthalmology/OorkAndOcrk/ocrkV1DiagnosticReportCustomControlData';
import type { IOorkV1DiagnosticReportCustomControlData } from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1DiagnosticReportCustomControlData';
import type { ValidationErrors } from '@frontend/utils/validation';
import { BooleanRadioGroupFormGroupField } from '@frontend/components/fields/BooleanRadioGroupField';
import { defaultBooleanRadioGroupFormGroupFieldProps } from '../types';
import { initialAfwijkingen } from '../utils/oorkV1DiagnosticReportInitializeCustomControlData';
import { AfwijkingenAddEdit } from './AfwijkingenAddEdit';

export interface IDiagnosticReportAfwijkingenAddEditProps {
    customControlData: IOorkV1DiagnosticReportCustomControlData | IOcrkV1DiagnosticReportCustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: <T = any>(values: Partial<T>) => Promise<void>;
    isRequired: boolean;
    validateOneCustomControl: (name: string, index?: number) => Promise<void>;
}

export function DiagnosticReportAfwijkingenAddEdit(props: IDiagnosticReportAfwijkingenAddEditProps) {
    const {
        customControlData: { afwijkingen_gevonden },
        isRequired,
        handleChangeCustomControl,
    } = props;

    useEffect(() => {
        if (!afwijkingen_gevonden) {
            resetAfwijkingen();
        }
    }, [afwijkingen_gevonden]);

    return (
        <>
            <BooleanRadioGroupFormGroupField
                {...defaultBooleanRadioGroupFormGroupFieldProps}
                automation="afwijkingen-gevonden"
                fieldKey="afwijkingen_gevonden"
                isRequired={isRequired}
                label="Afwijkingen gevonden"
                onChange={async (value) => {
                    handleChangeCustomControl({ afwijkingen_gevonden: value });
                }}
            />

            {afwijkingen_gevonden && <AfwijkingenAddEdit {...props} />}
        </>
    );

    function resetAfwijkingen(): Promise<void> {
        return handleChangeCustomControl({
            toelichting_verworven_nystagmus: null,
            afwijkingen: { ...initialAfwijkingen },
        });
    }
}
